/* ADN v6.0 · checkout real, anticipo, color en madera, accesorios completos
   y mensaje de WhatsApp con importes. Envuelve adn50shop.js / adn50producto.js. */
(function(){
"use strict";
var KEY="adn-cart-v4", CKEY="adn-color-v6";
var ANTICIPO_VARIANTE=49046485794999, BLOQUE=500;
var WA="https://wa.me/528683521850";
var CNAME={marron:"Marrón",negro:"Negro",blanco:"Blanco",naranja:"Naranja"};
var SM={
"platino-hibrido":{h:"adn-platino-hibrido"},
"max-hibrido":{h:"adn-max-hibrido"},
"platino":{h:"adn-platino"},
"max":{h:"adn-max"},
"master-plus":{h:"adn-master-plus",sz:"Mediano",col:1},
"master-plus-grande":{h:"adn-master-plus",sz:"Grande",col:1},
"pro":{h:"adn-pro",sz:"Mediano",col:1},
"pro-grande":{h:"adn-pro",sz:"Grande",col:1},
"rustico":{h:"adn-rustico",sz:"Mediano",col:1},
"rustico-grande":{h:"adn-rustico",sz:"Grande",col:1},
"campana":{h:"adn-campana-extraccion"},
"cajonera-triple":{h:"adn-cajonera-triple"},
"cajonera-cuadruple":{h:"adn-cajonera-cuadruple"},
"puertas-xl-dobles":{h:"adn-puertas-xl-dobles"},
"puertas-triples":{h:"puertas-triples"},
"base-puertas":{h:"base-con-puertas"},
"especiero":{h:"adn-especiero"},
"quemador-doble":{h:"adn-quemador-doble"},
"hielera-modulo":{h:"adn-hielera"},
"hielera-empotrable":{h:"hielera-empotrable"},
"bote-basura":{h:"adn-bote-basura"},
"puerta-individual-xl":{h:"puerta-individual-xl"}
};
/* catalogo completo de modulos para "Completa tu asador" */
var ICO={campana:"\uD83C\uDF00",cajones:"\uD83D\uDDC4",puerta:"\uD83D\uDEAA",frigo:"\uD83D\uDCE6",fuego:"\uD83D\uDD25",tarja:"\uD83E\uDDCA"};
var ACCS=[
{id:"campana",name:"Campana de Extracción",price:32990,icon:"campana",img:"https://cdn.shopify.com/s/files/1/0691/8265/2599/files/campana-instalada.jpg"},
{id:"cajonera-triple",name:"Cajonera Triple",price:10990,icon:"cajones"},
{id:"cajonera-cuadruple",name:"Cajonera Cuádruple",price:12990,icon:"cajones"},
{id:"quemador-doble",name:"Quemador Doble",price:7990,icon:"fuego"},
{id:"hielera-modulo",name:"Hielera (Módulo)",price:10990,icon:"tarja"},
{id:"hielera-empotrable",name:"Hielera Empotrable",price:6990,icon:"tarja"},
{id:"especiero",name:"Especiero",price:7990,icon:"frigo"},
{id:"bote-basura",name:"Bote de Basura",price:8990,icon:"frigo"},
{id:"puertas-xl-dobles",name:"Puertas XL Dobles",price:8990,icon:"puerta"},
{id:"puertas-triples",name:"Puertas Triples",price:12990,icon:"puerta"},
{id:"base-puertas",name:"Base con Puertas",price:13990,icon:"puerta"},
{id:"puerta-individual-xl",name:"Puerta Individual XL",price:4990,icon:"puerta"}
];
function mxn(n){ return "$"+Number(n).toLocaleString("es-MX"); }
function num(s){ return Number(String(s||"").replace(/[^0-9]/g,""))||0; }
function colorMap(){ try{ return JSON.parse(localStorage.getItem(CKEY))||{}; }catch(e){ return {}; } }
function colorOf(id){ var m=SM[id]; if(!m||!m.col) return null; return CNAME[colorMap()[id]||"marron"]||"Marrón"; }
var _pc={};
function prod(h){ if(!_pc[h]) _pc[h]=fetch("/products/"+h+".js").then(function(r){ if(!r.ok) throw new Error("producto no encontrado: "+h); return r.json(); }); return _pc[h]; }
function norm(s){ return String(s).toLowerCase(); }
function resolve(id){
var m=SM[id]; if(!m) return Promise.reject(new Error("sin mapeo: "+id));
return prod(m.h).then(function(p){
var vs=(p.variants||[]).filter(function(x){ return x.available!==false; });
if(!vs.length) vs=p.variants||[];
var toks=[];
if(m.sz) toks.push(m.sz);
if(m.col) toks.push(colorOf(id));
var v;
if(!toks.length){ v=vs[0]; }
else {
v=vs.filter(function(x){ var t=norm(x.title); return toks.every(function(k){ return t.indexOf(norm(k))>=0; }); })[0];
if(!v && m.sz) v=vs.filter(function(x){ return norm(x.title).indexOf(norm(m.sz))>=0; })[0];
}
if(!v) throw new Error("sin variante: "+m.h+" / "+toks.join(" + "));
return v.id;
});
}
var list=document.getElementById("cart-list");
var rows=document.getElementById("sum-rows");
var modes=document.getElementById("sum-modes");
function mode(){ var b=modes&&modes.querySelector(".paymode.on"); return b?b.dataset.k:"msi"; }
function readCart(){
var out=[];
if(!list) return out;
list.querySelectorAll(".cart-item").forEach(function(it){
var h=it.querySelector("h4");
out.push({
id:it.dataset.id,
name:h?h.textContent.trim():"",
color:colorOf(it.dataset.id),
price:num((it.querySelector(".pr")||{}).textContent),
q:num((it.querySelector(".qty span")||{}).textContent)||1
});
});
return out;
}
function plan(){
var items=readCart();
var total=items.reduce(function(s,i){ return s+i.price*i.q; },0);
var dep=Math.ceil(total*0.3/BLOQUE)*BLOQUE;
return { items:items, total:total, dep:dep, bloques:dep/BLOQUE, saldo:total-dep };
}
/* A · Carrito: el boton de pago abre el checkout real */
var btn=null;
var oldBtn=document.getElementById("sum-checkout");
if(oldBtn){
btn=oldBtn.cloneNode(true);
oldBtn.parentNode.replaceChild(btn,oldBtn);
btn.addEventListener("click",function(){
var lab=btn.textContent;
var p=plan();
if(!p.items.length) return;
btn.disabled=true; btn.textContent="Preparando tu pedido…";
function push(items){
return fetch("/cart/clear.js",{method:"POST",headers:{"Content-Type":"application/json"}})
.then(function(){ return fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:items})}); })
.then(function(r){ if(!r.ok) return r.json().then(function(j){ throw new Error(j.description||"add.js"); }); })
.then(function(){ window.location.href="/checkout"; });
}
var go;
if(mode()==="anticipo"){
var detalle=p.items.map(function(i){ return i.name+(i.color?" ("+i.color+")":"")+" × "+i.q; }).join(" · ");
go=push([{ id:ANTICIPO_VARIANTE, quantity:p.bloques, properties:{
"Proyecto":detalle,
"Total del proyecto":mxn(p.total),
"Anticipo pagado (30%)":mxn(p.dep),
"Saldo por liquidar":mxn(p.saldo)
}}]);
} else {
var c=p.items.filter(function(i){ return SM[i.id]; });
go=Promise.all(c.map(function(i){ return resolve(i.id).then(function(v){ return {id:v,quantity:i.q}; }); })).then(push);
}
go.catch(function(err){
btn.disabled=false; btn.textContent=lab;
console.error("[ADN checkout]",err);
if(window.adnToast) adnToast("No pudimos abrir el pago. Te llevamos a WhatsApp.");
var w=document.getElementById("sum-wa"); if(w) window.open(w.href,"_blank","noopener");
});
});
}
/* B · Carrito: color, cifras del anticipo, WhatsApp con importes, modulos completos */
if(list){
var st2=document.createElement("style");
st2.textContent=".adn-col{display:block;font-size:12.5px;color:#A2A2AB;margin-top:3px}.adn-col-in{color:#A2A2AB;font-weight:400}.sug-grid{max-height:none}";
document.head.appendChild(st2);
function waText(p){
var L=["Hola, quiero finalizar mi compra:",""];
p.items.forEach(function(i){
L.push("• "+i.name+(i.color?" · "+i.color:"")+(i.q>1?" × "+i.q:"")+" — "+mxn(i.price*i.q));
});
L.push("");
L.push("Total: "+mxn(p.total));
var m=mode();
if(m==="contado"){
var t=Math.round(p.total*0.9);
L.push("De contado con 10% de descuento: "+mxn(t));
L.push("Ahorro: "+mxn(p.total-t));
} else if(m==="msi"){
L.push("A 12 meses sin intereses: "+mxn(Math.round(p.total/12))+" al mes");
} else {
L.push("Anticipo del 30% para arrancar: "+mxn(p.dep));
L.push("Saldo por liquidar antes del envío: "+mxn(p.saldo));
}
return L.join("\n");
}
var busy=false;
function paint(){
if(busy) return;
busy=true;
var order=[];
list.querySelectorAll(".cart-item").forEach(function(it){
var col=colorOf(it.dataset.id);
order.push(col);
if(!col) return;
var h=it.querySelector("h4");
if(h && !(h.nextElementSibling&&h.nextElementSibling.classList.contains("adn-col"))){
var s=document.createElement("span");
s.className="adn-col"; s.textContent="Color: "+col;
h.parentNode.insertBefore(s,h.nextSibling);
}
});
if(rows){
rows.querySelectorAll(":scope > div").forEach(function(r,i){
var col=order[i]; if(!col) return;
var sp=r.querySelector("span");
if(sp && !sp.querySelector(".adn-col-in")){
var s=document.createElement("span");
s.className="adn-col-in"; s.textContent=" · "+col;
sp.appendChild(s);
}
});
}
var p=plan();
var amt=document.getElementById("sum-total-amt"), note=document.getElementById("sum-msi");
if(mode()==="anticipo" && p.items.length && amt && note){
amt.textContent=mxn(p.dep)+" hoy";
note.innerHTML="Anticipo del 30% redondeado a bloques de "+mxn(BLOQUE)+". Saldo por liquidar: <b>"+mxn(p.saldo)+"</b>, también diferible a 12 MSI.";
if(btn) btn.textContent="Pagar anticipo "+mxn(p.dep);
} else if(btn && btn.textContent.indexOf("Pagar anticipo")===0){
btn.textContent="Finalizar compra";
}
/* WhatsApp con importes */
var wa=document.getElementById("sum-wa");
if(wa && p.items.length) wa.href=WA+"?text="+encodeURIComponent(waText(p));
/* Completa tu asador: todos los modulos */
var box=document.getElementById("cart-sug"), grid=document.getElementById("sug-grid");
if(box && grid && p.items.length){
var inCart={}; p.items.forEach(function(i){ inCart[i.id]=1; });
var have={};
grid.querySelectorAll(".add").forEach(function(b){ have[b.dataset.id]=1; });
var falta=ACCS.filter(function(a){ return !inCart[a.id] && !have[a.id]; });
if(falta.length){
box.style.display="block";
var frag=document.createElement("div");
frag.innerHTML=falta.map(function(a){
var media=a.img?'<div class="sph"><img src="'+a.img+'" alt="" loading="lazy"></div>':'<span class="ico">'+ICO[a.icon]+'</span>';
return '<div class="sug">'+media+'<b>'+a.name+'</b><span class="pr">'+mxn(a.price)+'</span><button class="add" data-id="'+a.id+'">+ Agregar</button></div>';
}).join("");
while(frag.firstChild) grid.appendChild(frag.firstChild);
}
}
busy=false;
}
paint();
new MutationObserver(function(){ setTimeout(paint,0); }).observe(list,{childList:true,subtree:true});
if(rows) new MutationObserver(function(){ setTimeout(paint,0); }).observe(rows,{childList:true});
var grid0=document.getElementById("sug-grid");
if(grid0) new MutationObserver(function(){ setTimeout(paint,0); }).observe(grid0,{childList:true});
if(modes) modes.addEventListener("click",function(){ setTimeout(paint,0); });
}
/* C · Producto: selector de color en los modelos de madera */
var vars=document.getElementById("p-vars");
var PAL=[["Marrón","marron","#6B4A2F"],["Negro","negro","#1A1A1C"],["Blanco","blanco","#E8E4DC"],["Naranja","naranja","#C4571F"]];
var WOOD={"adn-rustico":"rustico","adn-master-plus":"master-plus","adn-pro":"pro"};
if(vars){
var slug=location.pathname.replace(/\/+$/,"").split("/").pop().toLowerCase();
var base=WOOD[slug];
if(base){
var st=document.createElement("style");
st.textContent=".vars-color{margin-top:14px}.opts-color{display:flex;gap:8px;flex-wrap:wrap}.col-opt{display:inline-flex;align-items:center;gap:8px}.col-opt i{width:16px;height:16px;border-radius:50%;border:1px solid rgba(255,255,255,.28);flex:none}";
document.head.appendChild(st);
var cw=document.createElement("div");
cw.className="vars vars-color";
cw.innerHTML='<span class="lab">Color de la madera</span><div class="opts opts-color">'+PAL.map(function(c,i){ return '<button type="button" class="var-opt col-opt'+(i?"":" on")+'" data-c="'+i+'"><i style="background:'+c[2]+'"></i>'+c[0]+'</button>'; }).join("")+'</div>';
vars.parentNode.insertBefore(cw,vars.nextSibling);
var ci=0;
cw.addEventListener("click",function(e){
var b=e.target.closest(".col-opt"); if(!b) return;
cw.querySelectorAll(".col-opt").forEach(function(o){ o.classList.remove("on"); });
b.classList.add("on"); ci=+b.dataset.c;
});
var stamp=function(){
var on=vars.querySelector(".var-opt.on");
var big=!!(on&&+on.dataset.i>0);
var cid=base+(big?"-grande":"");
var m=colorMap(); m[cid]=PAL[ci][1];
try{ localStorage.setItem(CKEY,JSON.stringify(m)); }catch(e){}
};
["p-buy","bb-buy"].forEach(function(bid){
var b=document.getElementById(bid);
if(b) b.addEventListener("click",stamp,true);
});
}
}
/* D · Home: encuadre de las fotos del comparador */
if(document.getElementById("cmp-table")){
var st3=document.createElement("style");
st3.textContent=".thp{aspect-ratio:1/1;background:#17171B;padding:8px}.thp img{object-fit:contain}";
document.head.appendChild(st3);
}
})();
